import React, { ReactElement } from 'react';
import { useDispatch } from 'react-redux';
import { showLoginModal } from '../../../features/login/login.slice';
import './LoginButton.scss';

export const LoginButton = (): ReactElement => {
  const dispatch = useDispatch();

  const showLogin = () => {
    dispatch(showLoginModal(true));
  };

  return <div className="app-bar__login-button" onClick={showLogin}></div>;
};
